export default {
  create() {
    return this.isAdmin();
  },
  destroy() {
    // https://trello.com/c/L8eA9sFY/288-drop-the-delete-button-to-destroy-a-medical-report-item
    return false;
  },
};
